import styled from "styled-components/macro";

import { useGetCurrentSignupList } from "Utilities/Hooks/useGetCurrentSignupList";

import SignupOption from "../SignupOption";

export default function PublicSignup() {
  const {
    options: { public: public_ },
    signupListStatusID,
  } = useGetCurrentSignupList();

  const isPublic = public_ > 0;

  return (
    <SignupOption
      text="Make this Signup public"
      name="public"
      on={isPublic}
      disabled={signupListStatusID !== 1}
    >
      <HelpText>
        Making a Signup public allows you to easily share a Signup with someone
        outside of your Flocknote network. This will allow you to use your
        Signup on social media or on your website.
      </HelpText>
    </SignupOption>
  );
}

const HelpText = styled.div`
  font-size: 15px;
  color: #828c8d;
  box-sizing: border-box;
  font-weight: 400;
  max-width: 600px;
`;
